import { useMemo } from 'react'
import debounce from 'lodash.debounce';
import { DEBOUNCE_DELAY } from 'Models/Constants';

type SearchDebounceCallback = (...args: any[]) => void;

export const useSearchDebounce = (callback: SearchDebounceCallback): SearchDebounceCallback => {
    return useMemo(() => debounce(callback, DEBOUNCE_DELAY), [callback]);
};